import { useState, useEffect } from 'react';

/**
 * Track which section is currently active based on scroll position
 * @param {Array} headingIds - Array of heading IDs to track
 * @returns {string} Currently active heading ID
 */
export const useActiveSection = (headingIds) => {
  const [activeId, setActiveId] = useState('');

  useEffect(() => {
    if (!headingIds || headingIds.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      {
        rootMargin: '-100px 0px -80% 0px', // Trigger when heading is near top
        threshold: 0
      }
    );

    // Observe all heading elements
    headingIds.forEach((id) => {
      const element = document.getElementById(id);
      if (element) {
        observer.observe(element);
      }
    });

    // Cleanup
    return () => {
      headingIds.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, [headingIds]);

  return activeId;
};